module.exports = __webpack_public_path__ + "static/media/session_preview.d3397e9c.PNG";